import Vue from 'vue'
import Router from 'vue-router'
import types from '../store/mutation-types'
import Tool from '../assets/tool/storage/index'

import store from '../store/index.js'

import Content from '../views/content/content.vue'
import About from '../views/about/about.vue'
import Novel from '../views/novel/novel.vue'


Vue.use(Router);

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            meta: {
                close: true
            },
        },
        {
            path: '/content/:id',
            name: 'content',
            component: Content,
        },
        {
            path: '/about',
            name: 'about',
            component: About,
        },
        {
            path: '/novel',
            name: 'novel',
            component: Novel,
            children: [
                {
                    path: '/novel/:id',
                    name: 'novel-content',
                    component: Content,
                    meta: {
                        catalog: true
                    },
                }
            ]
        }
    ]
});

/**
 * 判断用户是否有登录，没有登录则跳转到登录页面
 * 如果用户已经登录，则回跳到登录的页的时候，要转到首页
 * */
router.beforeEach( (to, from, next) => {
    // if( store ){
    //     if( from.meta.status > to.meta.status ) store.commit( types.SET_ANIMATE_NAME, 'vux-pop-out' );
    //     else store.commit( types.SET_ANIMATE_NAME, 'vux-pop-in' );
    // }
    // var user = Tool.dataToSessionStorageOperate.achieve('user');
    // if ( !user && to.path !== '/login' ){
    //     next('/login');
    // } else if ( user && to.path === '/login'){
    //     next('/');
    // } else {
        next();
    // }
});
export default router




// WEBPACK FOOTER //
// ./src/router/index.js